<template>

  <v-container fluid>
    <v-row>
      <v-col cols="6">
        <v-card>
          <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card height="200">
          <h1>loltroll</h1>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
export default {
  name: 'overview',
  data () {
    return {
      series: [{
        name: 'Page URLs',
        type: 'column',
        data: [440, 505, 414, 671, 227, 413, 201, 352, 752, 320, 257, 160]
      }, {
        name: 'Broken pages',
        type: 'line',
        data: [23, 42, 35, 27, 43, 22, 17, 31, 22, 22, 12, 16]
      }],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          toolbar: { show: false }
        },
        stroke: {
          width: [0, 4]
        },
        title: {
          text: 'Page status'
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [1]
        },
        labels: ['01 Jan 2001', '02 Jan 2001', '03 Jan 2001', '04 Jan 2001', '05 Jan 2001', '06 Jan 2001', '07 Jan 2001', '08 Jan 2001', '09 Jan 2001', '10 Jan 2001', '11 Jan 2001', '12 Jan 2001'],
        xaxis: {
          type: 'datetime'
        },
        yaxis: [{
          title: {
            text: 'URLS',
          },

        }, {
          opposite: true,
          title: {
            text: 'Broken'
          }
        }]
      },
    }
  }
}
</script>
